import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
// import { WindowRef } from 'src/app/shared/windowRef.service';
import { PaymentFormService } from './payment-form.service';
import { RazorpayOption } from 'src/app/shared/models';
import { Notification } from 'src/app/core/Notifications/Notification';
import Swal from 'sweetalert2';
import { WindowRef } from 'src/app/shared/windowRef.service';
declare var $: any;



@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss'],
  providers: [WindowRef]
})
export class PaymentFormComponent implements OnInit {
  private sub: any;
  PropertyDet: any = {};
  data: any;
  userRole: any;
  R: any = {};
  rzp1: any;
  options: RazorpayOption;
  orderData: any = {};
  transaction_id: any;
  result: any;
  mix_transaction_id: any;
  quickWord: any; // "QUICK"
  restData: any;   // "trn243234234234"

  constructor(private winRef: WindowRef, private notif: Notification, private service: PaymentFormService, private activatedRoute: ActivatedRoute, public router: Router) { }

  ngOnInit(): void {
    this.sub = this.activatedRoute.params.subscribe(params => {
      console.log("Transaction Id in payment page :" + this.activatedRoute.snapshot.paramMap.get('transaction_id') || '');
      this.transaction_id = this.activatedRoute.snapshot.paramMap.get('transaction_id') || ''

    });

    // The transaction_id variable
    //this.transaction_id = "QUICKtrn243234234234";

    // Check if "QUICK" is present in the string
    if (this.transaction_id.includes("QUICK")) {
      // Separate "QUICK" into one variable
      const quickWord = "QUICK";

      // Remove "QUICK" from the transaction_id to get the rest of the data
      const restData = this.transaction_id.replace("QUICK", "");

      // Log or use the variables as needed
      console.log("Quick Word:", quickWord);
      console.log("Rest of Data:", restData);

      // Optionally store them in class variables
      this.quickWord = quickWord; // "QUICK"
      this.restData = restData;   // "trn243234234234"
      this.transaction_id = this.restData
    }

    this.getOrderDetails(this.transaction_id)

  }

  getOrderDetails(Transaction_Id: any) {
    this.service.GetCustomerOrderDetailById(Transaction_Id)
      .subscribe(
        (data: any) => {
          this.orderData = data;
          this.payWithRazor(this.orderData);
        }, (error) => {
          //document.getElementById('loader-spinner').style.display = "none";
          // this.errorHandler.HandlerError(error);
          this.notif.errorsmsg(error)
        }
      );
  }

  payWithRazor(orderData: any) {
    let options: any = {
      "key": orderData.razorpay_key, //"rzp_test_6nc0ueIpVMNzjm",
      "amount": orderData.amount, //1
      "currency": orderData.currency, //'INR',
      "name": "Medetel",
      "description": orderData.description, // "test transaction data",
      "image": "../assets/images/AOL_MH.png",
      "order_id": orderData.order_id, //'order_JtDqcX8aHdUwbo', //order_id created by you in backend        
      "modal": {
        //We should prevent closing of the form when esc key is pressed.
        "escape": false
      },
      "prefill": {
        "name": orderData.name, //"Alex DM",
        "contact": orderData.phone_number, //"7829930855",
        "email": orderData.email// "alex.dm@gmail.com"

      },
      "notes": {
        "address": orderData.address, // "B Block, Line No - 2, No 456, JSR-831003, JH"
        "merchant_order_id": orderData.transaction_id
      },
      "theme": {
        "color": "#6fbc29"
      }
    };

    options.handler = ((response, error) => {
      options.response = response;
if(this.quickWord=='QUICK')
{
  //Quick Consultion
  this.service.CompleteOrderProcess_Quick(options.response)
        .subscribe(
          (data) => {
            console.log('verify success data :' + JSON.stringify(data));
            this.result = data;
            Swal.fire('Success!', ' Payment done successfully.', 'success').then((result) => {
              if (result.value) {
                // this.router.navigate(['/base/patient/join-meeting']);
                this.router.navigate(['/base/patient/join-meeting']).then(() => {
                  window.location.reload();
                });
              }
            })

          }, (error) => {
            this.notif.errorsmsg(error)
          });
}
else
{
  //normal portal consula
      this.service.CompleteOrderProcess(options.response)
        .subscribe(
          (data) => {
            console.log('verify success data :' + JSON.stringify(data));
            this.result = data;
            Swal.fire('Success!', ' Payment done successfully.', 'success').then((result) => {
              if (result.value) {
                // this.router.navigate(['/base/patient/join-meeting']);
                this.router.navigate(['/base/patient/join-meeting']).then(() => {
                  window.location.reload();
                });
              }
            })

          }, (error) => {
            this.notif.errorsmsg(error)
          });

        }

    });
    options.modal.ondismiss = (() => {
      this.notif.errorsmsg('Transaction cancelled.');
    });

    let rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

}
